import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import { Bell, Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import LegalAlertsCard from "@/components/legal/LegalAlertsCard";

const ITEMS = [
  { key: "ago_alerts", label: "AGO d'approbation des comptes", desc: "Rappels J-90/60/30/7 avant la limite (clôture + 6 mois)" },
  { key: "comptes_alerts", label: "Dépôt des comptes au greffe", desc: "Rappels avant la limite (clôture + 7 mois) et CVAE" },
  { key: "kbis_alerts", label: "Kbis de plus de 3 mois", desc: "Prévenir 7 jours avant que le dernier Kbis ne soit périmé" },
  { key: "registres_alerts", label: "Registres pas à jour", desc: "Chaque lundi si un registre obligatoire est à synchroniser ou manquant" },
];

export const LegalAlertsSettings = () => {
  const [s, setS] = useState(null);
  const [emails, setEmails] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/legal/alert-settings").then((r) => { setS(r.data); setEmails((r.data.recipients || []).join("\n")); }).catch((e) => toast.error(apiError(e)));
  }, []);
  const save = async () => {
    setBusy(true);
    try {
      const r = await api.put("/legal/alert-settings", { ...s, recipients: emails.split(/[\s,;]+/).filter(Boolean) });
      setS(r.data); setEmails(r.data.recipients.join("\n")); toast.success("Paramètres d'alertes enregistrés");
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  if (!s) return <div className="p-6 text-sm text-slate-500 flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" />Chargement…</div>;
  return (
    <div className="space-y-4" data-testid="legal-alerts-settings">
      <Card>
        <CardHeader className="pb-2"><CardTitle className="text-base flex items-center gap-2"><Bell className="w-4 h-4 text-indigo-600" />Alertes automatiques</CardTitle></CardHeader>
        <CardContent className="space-y-3">
          {ITEMS.map((it) => (
            <div key={it.key} className="flex items-center justify-between gap-4 p-3 rounded-lg border bg-white">
              <div><p className="text-sm font-medium">{it.label}</p><p className="text-xs text-slate-500">{it.desc}</p></div>
              <Switch checked={!!s[it.key]} onCheckedChange={(v) => setS({ ...s, [it.key]: v })} data-testid={`alert-switch-${it.key}`} />
            </div>
          ))}
          <div>
            <p className="text-sm font-medium mb-1">Destinataires (un email par ligne)</p>
            <Textarea rows={3} value={emails} onChange={(e) => setEmails(e.target.value)} placeholder="Vide = dirigeant / directeur financier de la société" data-testid="alert-recipients" />
          </div>
          <div className="flex justify-end">
            <Button onClick={save} disabled={busy} className="bg-indigo-600 hover:bg-indigo-700 text-white" data-testid="alert-save-btn">
              {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Save className="w-4 h-4 mr-1" />}Enregistrer</Button>
          </div>
        </CardContent>
      </Card>
      <LegalAlertsCard />
    </div>
  );
};
